import React, { useEffect, useRef, useState } from "react";
import Income from "./Income";
import Yields from "./Yields";
import IrrigatedArea from "./IrrigatedArea";
import SchemeCount from "./SchemeCount";
import IwuaCounCard from "./IwuaCounCard";
import IrrigationMethods from "./IrrigationMethods";
import YieldCropGraph from "./YieldCropGraph";
import TotalProduction from "./TotalProduction";
import LeafletMap from "./LeafletMap";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { Form, Select } from "antd";
import CardLoading from "../../../components/CardLoading";

function OverviewList() {
  const [active, setActive] = useState("Overview");
  const handleChange = (value) => {
    setActive(value);
  };
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [selectId, setSelectId] = useState(null);

  const urlPathway = "api/v2/irrigationPathway/get";

  const dispatch = useDispatch();
  const url = "api/v2/dashboard/getAllDashboardData";
  const { loading, data, count, dataPathway } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    dataPathway: state.fetch.data[urlPathway] || [],
  }));

  async function fetchDashData() {
    await dispatch(
      fetchData({
        url: url,
        pathwayId: selectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
  }, []);

  useEffect(() => {
    fetchDashData();
  }, [selectId]);
  if (loading) return <CardLoading />;

  return (
    <>
      <div className="flex lg:flex-row flex-col lg:items-center lg:justify-between gap-[.75rem]">
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          className="lg:w-[20%] w-full"
          form={form}
        >
          <div className="w-full banner-select flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Pathway</span>
            <Select
              className="banner-selector"
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataPathway?.length > 0 &&
                dataPathway?.map((item) => ({
                  value: item?.irrigationPathwayId,
                  label: item?.irrigationPathwayName,
                }))
              }
              value={selectId}
              onChange={(value) => setSelectId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>
        </Form>
        <div className="border border-[#D6E1F5] rounded-[1.5rem] p-[.5rem] bg-white flex items-center gap-x-[.5rem] w-auto">
          <button
            onClick={() => handleChange("Overview")}
            className={`py-[0.375rem] px-[.75rem] rounded-[1.5625rem] text-[.75rem] font-[400] font-interSans  ${
              active === "Overview"
                ? "text-white bg-darkBlue"
                : "text-[#424242] bg-white"
            }`}
          >
            Overview
          </button>
          <button
            onClick={() => handleChange("Map")}
            className={`py-[0.375rem] px-[.75rem] rounded-[1.5625rem] text-[.75rem] font-[400] font-interSans  ${
              active === "Map"
                ? "text-white bg-darkBlue"
                : "text-[#424242] bg-white"
            }`}
          >
            Map Analysis
          </button>
        </div>
      </div>
      {active === "Overview" ? (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[1.25rem] mt-[.75rem] w-full">
            <SchemeCount />
            <IrrigatedArea />
            <Yields />
          </div>
          <div className="mt-[1.25rem] grid sm:grid-cols-2 lg:grid-cols-2 gap-[1.25rem] w-full">
            <IrrigationMethods />
            <Income />
          </div>
          <div className="mt-[1.25rem] grid sm:grid-cols-2 lg:grid-cols-2 gap-[1.25rem] w-full">
            <YieldCropGraph />
            <TotalProduction />
          </div>
          <div className="mt-[1.25rem]">
            <IwuaCounCard />
          </div>
        </>
      ) : (
        <LeafletMap />
      )}
    </>
  );
}

export default OverviewList;
